export default __webpack_public_path__ + "static/media/google-play.c48f126c.svg";